@if (!isLoading && siteAddressAttributeData?.tabs?.[0]?.groups) {
  <div class="add-delivery-address">
    <app-mi-form [attributeLabels]="attributeLabels" [attributeValues]="attributeValues" [moduleName]="moduleName" [groups]="siteAddressAttributeData.tabs[0].groups"
                (saveData)="onSaveAddress($event)" (previousClick)="onPreviousClick()" [showImg]="true" [isMultipleFilesUpload]="false"
                [submitBtnText]="nextBtnLabel" [previousBtnText]="previousBtnLabel" [activeIndex]="activeIndex" saveBtnId="addressSaveBtnId"
                [showCancelButton]="true" (onCancel)="onCancel()"></app-mi-form>
  </div>
} @else {
  <div class="loading-spinner">
    <p-progressSpinner></p-progressSpinner>
  </div>
}